// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductPrice, { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import * as React from "react";
import { connect } from "react-redux";

type OwnProps = WidgetProps & HasProductContext & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState) => ({
    productSettings: getSettingsCollection(state).productSettings,
});

export interface ProductDetailsPriceStyles {
    productPrice?: ProductPriceStyles;
    selectForPricingStyling?: TypographyProps;
}

export const priceStyles: ProductDetailsPriceStyles = {
    productPrice: {
        price: {
            priceText: { size: 26 },
            unitOfMeasureText: { size: 26 },
        },
    },
};

const styles = priceStyles;

const ProductDetailsPrice: React.FC<OwnProps> = ({ productContext, productSettings }) => {
    // XNG-Change diplaying siteMessage incase of parent product
    return (
        <>
            {productContext.product.isVariantParent ? (
                <Typography {...styles.selectForPricingStyling}>
                    {siteMessage("Custom_PDP_Select_For_Pricing_Text")}
                </Typography>
            ) : (
                <ProductPrice
                    product={productContext}
                    showLabel={false}
                    showSavings={true}
                    showSavingsAmount={productSettings.showSavingsAmount}
                    showSavingsPercent={productSettings.showSavingsPercent}
                    extendedStyles={styles.productPrice}
                />
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProductContext(ProductDetailsPrice)),
    definition: {
        displayName: "Price",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
